export default __webpack_public_path__ + "static/media/bei_dir_bin_ich_zu_hause_cover.c8735edf.webp";